import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';

const filterConfig = [
  { id: 'Busca', type: 'text', label: 'Buscar', placeholder: 'Nome, CNPJ ou raiz' }
];

const JanelasFilter = ({ filtros, onApply, loading, children }) => (
  <Row>
    <Col md={12}>
      <FilterPanel
        filters={filterConfig}
        values={filtros}
        onApply={onApply}
        title="Filtros de Janelas"
        loading={loading}
        defaultCollapsed={false}
      >
        {children}
      </FilterPanel>
    </Col>
  </Row>
);

export default JanelasFilter;
